import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";
import type {
  GetTranscriptionsPayload,
  GetTranscriptionsResponse,
  GetTranscriptionZoomPayload,
  GetTranscriptionZoomResponse,
} from "@/commons/types/api/api.types";

export type FetchTranscriptionsListParams = Omit<
  GetTranscriptionZoomPayload,
  "source"
> & { source: string | null };

export const fetchTranscriptionsList = async ({
  source,
  ...others
}: FetchTranscriptionsListParams) => {
  try {
    const response = await httpRequest<
      GetTranscriptionsResponse,
      GetTranscriptionsPayload
    >("post", "/transcriptions", {
      source: source?.length ? [source] : undefined,
      ...others,
    });
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};

export const fetchOneTranscription = async (
  payload: GetTranscriptionZoomPayload
) => {
  try {
    const response = await httpRequest<
      GetTranscriptionZoomResponse,
      GetTranscriptionZoomPayload
    >("post", "/transcription-zoom", payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
